<template>
  <div id="HvutUnitDetail">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div id="page-content-wrapper" class="admin-content-area" >
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">HVUT Unit Detail</div>
          <div class="web-action-btn btn-groups text-right">
              <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                  <i class="fp-export"></i> Export
              </a>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content contact-list">
            <data-table-filter-config :moduleName="'hvutunitDetail'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
              <section class="bg-white data-table">
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange" :moduleName="'hvutunitDetail'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  mode="remote"
                  ref="hvutunitDetailTable"
                  title="hvutunitDetail"
                  @on-page-change="onPageChange"
                  @on-sort-change="onSortChange"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-select-all="onSelectAll"
                  @on-selected-rows-change="selectionChanged"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :paginationOptions="{
                      enabled: false,
                      position: 'both',
                      perPage: perPage,
                      dropdownAllowAll: false,
                      setCurrentPage:listCurrentPage,
                      perPageDropdown:dropDownPerPage,
                  }"
                  :search-options="{
                  enabled: false,
                  }"

                  >
                </vue-good-table>
                <custom-pagination
                    :page-changed="onPageChange"
                    :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
              <h1>
                  Oops!</h1>
              <h2>
                  403 </h2>
              <div class="error-details">
                  Sorry!, You don't have permission to access this page.
              </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
 import {commonMixins} from '../../mixins/commonMixins';
 import {dataTableMixins} from '../../mixins/dataTableMixins';
export default {
  name: "HvutUnitDetail",
  metaInfo() {
            return {title: "HVUT Unit Detail | " +process.env.COPYRIGHT_NAME}
        },
  mixins: [commonMixins,dataTableMixins],
  data: () => ({
    cantAccessPage:"",
    loading: false,
    action:'list',
    permissions:[],
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns:[
      {
          label: 'Unit Number',
          field: 'unit_no',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Unit Description',
          field: 'unit_description',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
          // sortable:false,
      },
      {
          label: 'Equip Sts',
          field: 'vehicle_status',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "All", // placeholder for filter input
              filterDropdownItems: ['Sold', 'Active', 'Void', 'In Garage'],
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
      },
      {
          label: 'Owner',
          field: 'owner',
          hidden:false,
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'HVUT Year',
          field: 'hvutyear',
          hidden:false,
          fpFieldType:"integer",
          filterable: true,
      },
      {
          label: 'HVUT GVW',
          field: 'hvutgvw',
          fpFieldType:"integer",
          hidden:false,
          filterable: true,
      },
      {
          label: 'HVUT Category',
          field: 'hvutcategory',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'HVUT Start Month',
          field: 'hvutstartmonth',
          hidden:false,
          fpFieldType:"integer",
          filterable: true,
      },
      {
          label: 'Cost',
          field: 'cost',
          fpFieldType:"integer",
          hidden:false,
          type:'number',
          filterable: true,
          filterOptions: {
              enabled: false, // enable filter for this column
              placeholder: "Cost", // placeholder for filter input
              filterValue: '', // initial populated value for this filter
              trigger: "enter" //only trigger on enter not on keyup
          },
          // sortable:false
      },
      {
          label: 'Billback Amount',
          field: 'billback_amount',
          fpFieldType:"integer",
          hidden:false,
          filterable: true,
          type:'number',
          // sortable:false,
      },
      {
          label: 'Amortized',
          field: 'amount_amortized',
          fpFieldType:"integer",
          hidden:false,
          filterable: true,
          type:'number',
      },
      {
          label: 'Remaining Amount',
          field: 'remaining_amount',
          fpFieldType:"integer",
          hidden:false,
          filterable: true,
          type:'number',
      },
      {
          label: 'Schd Sts',
          field: 'schd_status',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'HVUT Customer',
          field: 'hvut_customer_number',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
          sortable:true,
      },
      {
          label: 'HVUT Customer Name',
          field: 'hvut_customer',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
       {
          label: 'HVUT Facility',
          field: 'location',
          hidden:false,
          fpFieldType:"option",
          filterable: true,
      },
      {
          label: 'Invoice Number',
          field: 'invoice',
          hidden:false,
          sortable: true,
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Unit GVW',
          field: 'gvw',
          fpFieldType:"integer",
          hidden:false,
          filterable: true,
          type:'number',
      },
      {
          label: 'Unit Year',
          field: 'gvw_year',
          fpFieldType:"integer",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Model',
          field: 'model',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Make',
          field: 'manufacturer_code',
          hidden:false,
          fpFieldType:"text",
          filterable: true,
      },
      {
          label: 'Serial Number',
          field: 'vin',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'In Service Date',
          field: 'date_in_service',
          hidden:false,
          fpFieldType:"custom_date",
          filterable: true,
      },
      {
          label: 'Equipment Type',
          field: 'equip_type',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Equipment Group',
          field: 'equip_grp',
          fpFieldType:"text",
          filterable: true,
          hidden:false,
      },
      {
          label: 'Contract Type',
          field: 'contract_type',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Agrmt Type',
          field: 'agreement_type',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable: false,
      },
      {
          label: 'Agrmt Number',
          field: 'agreement_no',
          hidden:false,
          filterable: true,
          fpFieldType:"text",
      },
      {
          label: 'Billback Allowance',
          field: 'billback_allowance',
          hidden:false,
          filterable: false,
          fpFieldType:"text",
          sortable: false,
      },
      {
          label: 'Current Facility',
          field: 'vehicle_location',
          fpFieldType:"option",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Current Pool',
          field: 'pool',
          hidden:false,
          filterable: true,
          fpFieldType:"option",
      },
      {
          label: 'Current Customer',
          field: 'cur_customer',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Current Customer Name',
          field: 'cur_customer_name',
          fpFieldType:"text",
          hidden:false,
          filterable: true,
      },
      {
          label: 'Admin Fee',
          field: 'admin_fee',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable: false,
      },
      {
          label: 'Adj Cost',
          field: 'adj_cost',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable: false,
      },
      {
          label: 'Adj Billback',
          field: 'adj_billback',
          fpFieldType:"text",
          hidden:false,
          filterable: false,
          sortable: false,
      },
    ],
    batchProcess:0,
    batchNum:"",
  }),
  watch:{
    permissions: function(permission) {
        var self = this;
        permission.forEach(function (permissions) {
            if(permissions.name == 'hvut_unit_detail') {
                self.cantAccessPage = true;
            }
        });
        if(self.cantAccessPage == ''){
            self.cantAccessPage = false;
        }
    },
  },
  mounted: function(){
    var self = this;
    self.getPermissions();
  },
  methods:{
    cancelAll: function (cancelAll) {
      this.$refs.hvutunitDetailTable.unselectAllInternal();
    },
    loadList: function(){

      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();

      $.ajax({
        url: process.env.ROOT_API + "/hvut-unit-report/list",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          action:self.action,


        },
        success: function(data) {
          self.loading = false;

          console.log(data.content.row);
          if (data.status == "success") {

            if (self.action == "export" ||  self.action == "export_queue") {

                if ( data.code == "201" ) {
                    alert(data.message);
                } else {

                    if ( self.action == "export" ) {

                        self.excel = data.content.web;
                        var save = document.createElement("a");
                        save.href = self.excel;
                        save.download = data.content.web;
                        save.target = "_blank";

                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);

                    } else {

                        self.batchProcess = 1;
                        self.batchNum = data.content;
                    }

                }

              self.action = "list";
              // self.loadList();

            } else {
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;
            }


          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'hvut-unit-report')
        }
      });


    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reports/HvutUnitDetail.vue